import React from 'react';
import styled from '@emotion/styled';
import { PrimaryButton } from '../buttons/PrimaryButton';
import ErrorIcon from '../icons/ErrorIcon';
import { defaultTheme } from '../../config/theming';
import StatusBarWrapper from './StatusBarWrapper';

const ErrorStatusBarWrapper = styled(StatusBarWrapper)`
  background-color: ${defaultTheme.colors.error};

  & button {
    font-size: 0.75rem;
    font-weight: 600;
  }
`;

const openSupportTicketURL = 'https://support.liveoptics.com/hc/en-us/requests/new';
const openSupportTicketPage = () => {
  window.open(openSupportTicketURL, '_blank');
};

export const ErrorStatusBar = () => {
  return (
    <ErrorStatusBarWrapper data-testid="error-status-bar">
      <ErrorIcon />
      <p>
        This project is in an error state. No further processing will be done automatically. We
        recommend opening a ticket with Live Optics Support.
      </p>
      <PrimaryButton clickFn={openSupportTicketPage}>Open Support Ticket</PrimaryButton>
    </ErrorStatusBarWrapper>
  );
};

export default ErrorStatusBar;
